module.exports = __webpack_public_path__ + "static/media/lk.e2612d61.svg";